export const isScUrl = () => window.location.host.startsWith('www-sc');
